import { FC, useEffect, useState } from "react"
import { useAppContext } from "../../../system/providers/appContextProvider";
import { LotDataProvider } from "../../../Services/DataProviders/LotDataProvider";
import { IActualPricesLotViewDTO } from "../../../libs/coreapi-dto/accounting/lot";
import useGridFilter, { DefaultDatePeriod, DefaultLotGridFilter } from "../../../system/hooks/useGridFilter";
import { DocumentType,LoadingStatus } from "../../../@types/enumsGlobal";
import styles from '../../styles/index.module.scss'
import { Spinner } from "../../../components/spiner/Spinner";
import { DefaultGrid } from "../../../components/grids/default/defaultGrid";
import { usePluginContext } from "../../../system/providers/plugin";
import { PluginWrapper, ToolbarWrapper } from "../../../components/plugins";
import { GoodsDataProvider } from "../../../Services/DataProviders/GoodsDataProvider";
import { ActualPricesPanel } from "../../../components/commandsPanels/ActualPricesPanel";
import stylesActualPrices from "../ActualPricesLot/Styles/ActualPriceLot.module.scss";

const ActualPricesLotPluginView: FC<IGridProps> = (props) => {
    const appContext = useAppContext()
    const lotDataProvider = new LotDataProvider(appContext.coreApiService)
    const goodsDataProvider = new GoodsDataProvider(appContext.coreApiService)
    const pluginCtx = usePluginContext()
    
    const [data, setData] = useState<IActualPricesLotViewDTO[]>([]);
    const [gridFilter, dispatchGridFilter] = useGridFilter({...DefaultLotGridFilter, paramFilter: {dateSaleFrom: DefaultDatePeriod.startDate, dateSaleTo: DefaultDatePeriod.endDate}});
    const [viewState, setViewState] = useState<GridStateType>("view");
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.NoData);
    const [totalCount, setTotalCount] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [isAllSelect, setIsAllSelect] = useState<boolean>(false)
    const [selectedItemsInverion, setSelectedItemsInverion] = useState<IGridRow[]>([]);
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([]);
    const [multipleSelect] = useState<boolean>(true);
    const isAllowCreateDocument = !(selectedItems.length > 0)
    const [loadDataTimeout, setLoadDataTimeout] = useState<NodeJS.Timeout>();

    useEffect(() => {
        if (loadDataTimeout) clearTimeout(loadDataTimeout);
        if (viewState == 'refresh') {
            setViewState('view') 
            return
        }
        setIsSubmitting(true)
        setLoadDataTimeout(setTimeout(() => {
            lotDataProvider.getViewActualPrices(gridFilter, (data, totalCount) => {
                setData(data)
                setTotalCount(totalCount)
                data.length > 0 ? setLoadingStatus(LoadingStatus.Completed) : setLoadingStatus(LoadingStatus.NoData)
                setIsSubmitting(false)
                localStorage.removeItem('journalFilters');
            })
        }, 300))


    },[viewState,gridFilter])

    useEffect(() => {
        if (!isAllSelect) setSelectedItemsInverion([])
    },[isAllSelect])

    const onChangeMultipleSelect = (rows: ISelectGridRow[], currentRow?: IGridRow): void => {
        if (rows) {
            if (isAllSelect && currentRow) {
                setSelectedItemsInverion?.(prev => {
                    const isExisting = prev.some(item => item.idGlobal === currentRow.idGlobal);

                    if (isExisting) {
                        // Если элемент найден, удаляем его.
                        return prev.filter(item => item.idGlobal !== currentRow.idGlobal);
                    } else {
                        // Если элемента нет, добавляем его.
                        return [...prev, currentRow];
                    }
                });
            }
        }
    }

    return <>
     <PluginWrapper>
        <ToolbarWrapper>
            <ActualPricesPanel 
                dispatchGridFilter={dispatchGridFilter}
                selectedItems={selectedItems}
                selectedItemsInverion={selectedItemsInverion}
                gridFilter={gridFilter}
                isAllowCreateDocument={isAllowCreateDocument}
                selectAll={[isAllSelect,setIsAllSelect]}
                goodsDataProvider={goodsDataProvider}
                lotDataProvider={lotDataProvider}
                plugin={props.plugin}
                setViewState={(vs) => setViewState(vs)}
                selectedItem={[selectedItem, setSelectedItem]}
                refresh={{
                    onClick: () => {
                        setViewState("refresh");
                        setSelectedItem(undefined);
                    },
                }}
            />
        </ToolbarWrapper>
        <div className={styles.pluginWorkspace}>
            <div className={styles.gridWrapper}>
                <div className={styles.masterGrid}>
                    {
                        isSubmitting ? <Spinner /> :<DefaultGrid
                            gridId={props.gridId}
                            data={data}
                            quantityPosition
                            separator                                
                            singleDirectory
                            loadingStatus={loadingStatus}
                            setLoadingStatus={setLoadingStatus}
                            totalCount={totalCount}
                            filter={gridFilter}
                            plugin={props.plugin}
                            multipleSelect={multipleSelect}
                            selectedItems={selectedItems}
                            dataProvider={lotDataProvider}
                            getStyleRow={(item) => {
                                const cell = item.cells.find(x => x.propertyName === 'differencePercent')
                                if (cell?.value > 5) return stylesActualPrices.rowDanger
                                return null;
                            }}
                            getView={(gridFilter,callback) => {
                                lotDataProvider.getViewActualPrices(gridFilter, (entities) => {
                                    callback(entities)
                                    setSelectedItem(undefined);
                                })
                            }}
                            selectedItem={selectedItem}
                            //setPluginSettings={(plugin) => setPluginSettings(plugin)}
                            onSelect={(row) => {
                                setSelectedItem(row)
                                row
                                    ? pluginCtx.masterGrid.onSelectEvent(row, DocumentType.lots)
                                    : pluginCtx.masterGrid.onUnselectEvent()
                            }}
                            onMultipleSelect={(rows,currentRow) => {
                                setSelectedItems(rows)
                                onChangeMultipleSelect(rows, currentRow)
                            }}
                            onSort={(i) => { dispatchGridFilter({ type: "sort", payload: i.propertyName }) }}
                            onFilterDelete={(i) => { dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName }) }}
                            onPageNumberChange={(n) => { dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } }) }}
                            onNumberPerPageChange={(n) => { dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } }) }}
                            hiddenPagination={{ hiddenNumberPage: true, hiddenCountRow: true, selectAllItems: isAllSelect }}
                        />
                    }
                </div>                    
            </div>
        </div>
        </PluginWrapper>
    </>
}

export default ActualPricesLotPluginView